import React from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';
import LegCard from "../ItinerarySelector/LegCard";
import { useSelectedStopover } from "../../../providers";
import PropTypes from 'prop-types';
const StopoverSelector = ({
  legs,
  setDisabledButton,
  trackingOnChange
}) => {
  const [isChecked, setIsChecked] = useSelectedStopover();
  const onChange = position => {
    const updatedCheckedState = isChecked.map((item, index) => index === position ? !item : false);
    const isSomeChecked = updatedCheckedState.find(elem => elem === true);
    setDisabledButton(!isSomeChecked);
    setIsChecked(updatedCheckedState);
    trackingOnChange();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, legs.map((leg, index) => {
    const isLast = index === legs.length - 1;
    return /*#__PURE__*/React.createElement(Box, {
      pb: isLast ? '' : ['big', '1x_big'],
      key: index
    }, /*#__PURE__*/React.createElement(LegCard, {
      leg: leg,
      isChecked: isChecked[index],
      onChange: () => onChange(index),
      showRadioButton: true
    }));
  }));
};
export default StopoverSelector;
StopoverSelector.StopoverSelector = {
  legs: PropTypes.array.isRequired,
  setDisabledButton: PropTypes.func.isRequired,
  trackingOnChange: PropTypes.func.isRequired
};